import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { AuthoringRichTextReadOnly } from "authoring/components/authoring-rich-text-readonly"
import { hasAmendsContent } from "authoring/routes/project/amends/lib/amends-content"
import { ScheduleCommentaryOverviewItem } from "./schedule-commentary-overview-item"
import { ScheduleCommentaryEditOverviewButton } from "./schedule-commentary-edit-overview-button"

// Generated lines first, then the author's own text (e.g. withdrawn schedules, which can't be counted).
export function ScheduleCommentaryOverviewSection({ title, items, content }) {
    return (
        <Box data-cy="schedule-commentary-overview-section">
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 1.5 }}>
                <Typography variant="h6" sx={{ color: "primary.main", fontWeight: 700 }}>
                    {title}
                </Typography>
                <ScheduleCommentaryEditOverviewButton overview={{ title, content }} />
            </Stack>
            <Stack spacing={0.5} sx={{ pl: 3 }}>
                <Repeat list={items} item={<ScheduleCommentaryOverviewItem />} keyFn={(line) => line.key} />
                <If truthy={hasAmendsContent(content)}>
                    <AuthoringRichTextReadOnly content={content} dataCy="schedule-commentary-overview-content" />
                </If>
            </Stack>
        </Box>
    )
}
